import styled from 'styled-components'

import { device } from '~/styles/device'

export const Container = styled.div`
  display: flex;

  @media ${device.laptop_max} {
    flex-direction: column;
  }
`

export const SectionWrapper = styled.div`
  border-color: ${({ theme }) => theme.colors.tertiary};

  border-left-width: 1px;
  border-left-style: solid;
  padding-left: 1.5rem;
  margin-left: 1.5rem;

  @media ${device.laptop_max} {
    border-left-width: 0;
    border-left-style: none;
    padding-left: 0;
    margin-left: 0;

    border-top-width: 1px;
    border-top-style: solid;
    padding-top: 1rem;
    margin-top: 1rem;
  }
`

export const Title = styled.strong`
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
`

export const Text = styled.p`
  margin: 0;
  padding: 0;
`
